<h1 class="cg-h1">{{ 'am.pageTitle' | translate }}</h1>
<div class="cg-margin-bottom-xl">
  <p>{{ 'am.overview.instructions' | translate }}</p>
  <a
    cignaButton="primary"
    routerLink="new"
    (click)="addNewUser()"
    data-test="wam-overview-add-new-button"
    [cignaTrackClicks]="[
      'trackEventOther',
      'Add New Users',
      'ac-WC012-Add Start',
      {
        eVar101: 'Manage User Access:Add New User'
      }
    ]"
  >
    {{ 'am.common.addUsersBtn' | translate }}
  </a>
  <cigna-wams-help-dropdown></cigna-wams-help-dropdown>
</div>

<div class="cg-datatable__top cg-clearfix cg-margin-bottom-lg">
  <cigna-datatable-action-links
    (actionChange)="onFilterStateChange($event)"
    [actions]="overviewTableFilterActions"
    [selectedAction]="overviewSelectedFilterGroup$ | async"
    actionHeader="View Users"
  >
  </cigna-datatable-action-links>
</div>

<div class="cg-datatable__top cg-clearfix searchbar-border">
  <div class="cg-datatable__top-right">
    <cigna-filter-text-input
      [placeholder]="'am.common.searchInputPlaceholder' | translate"
      darkBg="true"
      (inputChange)="onFilterTextChange($event)"
    >
    </cigna-filter-text-input>
  </div>
</div>

<cigna-resizeable-height-container [height]="350">
  <cigna-user-overview-table
    (userSelected)="onUserSelectChange($event)"
    (usersToggleAll)="onUsersToggleAll($event)"
    (userSelectAndEdit)="onUserSelectAndEdit($event)"
    [stage]="userTableView$ | async"
    [users]="overviewUsers$ | async"
    [amUserId]="amUserId$ | async"
    [amLob]="amLob$ | async"
    [isImpersonator]="impersonator$ | async"
    [filterText]="overviewFilterText$ | async"
    [filterGroup]="overviewSelectedFilterGroup$ | async"
  >
  </cigna-user-overview-table>
</cigna-resizeable-height-container>

<div class="cg-button-group cg-margin-top-lg">
  <button
    [disabled]="(selectedUsersLength$ | async) === 0"
    (click)="viewAndEditUsers()"
    cignaButton="primary"
    data-test="wam-overview-view-edit-button"
    [cignaTrackClicks]="[
      'trackEventOther',
      'View and edit selected Users',
      'ac-WC019-View Edit',
      {
        eVar101: 'Manage User Access:Edit User',
        events: 'event443'
      }
    ]"
  >
    {{ 'am.common.viewEditUsersBtn' | translate }}
  </button>
</div>
